// @core/api/endpoints/legalentity/set_default_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LegalEntityResponse,
  SetDefaultLegalEntityRequest,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Set as tenant's default legal entity
 * Marks this legal entity as the default contracting side for its tenant. Clears is_default on the previous default. Used to pre-fill 'our side' when starting a new contract.
 */
export async function SetDefaultLegalEntity(
  legal_entity_id: string,
  data: SetDefaultLegalEntityRequest,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id/default`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.post<LegalEntityResponse>(requestPath, data, requestOptions);
}
